import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeneralInfoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 19 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "stroke",
		d: "M8.8956 19.552C13.5243 19.552 17.2766 15.7997 17.2766 11.1711H8.8956L8.89565 2.79008C4.26696 2.79005 0.514648 6.54237 0.514648 11.1711C0.514648 15.7997 4.26693 19.552 8.8956 19.552Z"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.5623 1.21851V7.42363H18.3242V6.98041C18.3242 3.7982 15.7445 1.21851 12.5623 1.21851Z",
		className: "stroke"
	})]
});
export default SvgGeneralInfoIcon;
